import { CnDateRangePickerPro as UiCnDateRangePickerPro } from '@/components/cn-date-picker-pro';
import { connect, mapProps } from '@formily/react';
import { mapSize, mapStatus } from '../__builtins__';
export var CnDateRangePickerPro = connect(UiCnDateRangePickerPro, mapProps(mapSize, mapStatus));
